import { alpha } from '@mui/material';

import { COLOR_PALETTE, mediaQuery, MOBILE_BOTTOM_NAV } from 'constants/ui';

import { AI_ASSISTANT_LAUNCHER_Z_INDEX } from '../../AiAssistant.constants';

import {
  LAUNCHER_COLLAPSED_SIZE,
  LAUNCHER_COLLAPSED_SIZE_MOBILE,
  LAUNCHER_EXPAND_DURATION_MS,
  LAUNCHER_OFFSET,
  LAUNCHER_OFFSET_MOBILE,
  LAUNCHER_SHADOW_HOVER_OPACITY,
  LAUNCHER_SHADOW_OPACITY,
} from './AiAssistantLauncher.constants';

const LAUNCHER_GRADIENT = `linear-gradient(135deg, ${COLOR_PALETTE.BRAND[6]} 0%, ${COLOR_PALETTE.PURPLE[7]} 100%)`;

export const launcherContainerStyles = {
  position: 'fixed',
  bottom: `${LAUNCHER_OFFSET}px`,
  right: `${LAUNCHER_OFFSET}px`,
  zIndex: AI_ASSISTANT_LAUNCHER_Z_INDEX,
  display: 'flex',
  alignItems: 'center',
  pointerEvents: 'none',
  // On mobile the floating bottom-nav occupies the same bottom-right corner, so lift the launcher
  // above the bar (its GAP from the bottom + HEIGHT + a margin) and track the same safe-area inset
  // the bar uses, so it never hides behind the menu bar. env() is 0 off-device.
  [mediaQuery.mobile]: {
    bottom: `calc(${
      MOBILE_BOTTOM_NAV.GAP + MOBILE_BOTTOM_NAV.HEIGHT + LAUNCHER_OFFSET_MOBILE
    }px + env(safe-area-inset-bottom, 0px))`,
    right: `${LAUNCHER_OFFSET_MOBILE}px`,
  },
};

export const launcherButtonStyles = isExpanded => ({
  position: 'relative',
  pointerEvents: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: isExpanded ? 'flex-start' : 'center',
  height: `${LAUNCHER_COLLAPSED_SIZE}px`,
  minWidth: `${LAUNCHER_COLLAPSED_SIZE}px`,
  width: isExpanded ? '280px' : `${LAUNCHER_COLLAPSED_SIZE}px`,
  padding: isExpanded ? '8px 20px 8px 8px' : 0,
  borderRadius: `${LAUNCHER_COLLAPSED_SIZE / 2}px`,
  background: LAUNCHER_GRADIENT,
  color: COLOR_PALETTE.GRAY[1],
  boxShadow: `0 10px 28px ${alpha(COLOR_PALETTE.BRAND[6], LAUNCHER_SHADOW_OPACITY)}`,
  textTransform: 'none',
  cursor: 'pointer',
  overflow: 'hidden',
  transition: `width ${LAUNCHER_EXPAND_DURATION_MS}ms ease, padding ${LAUNCHER_EXPAND_DURATION_MS}ms ease, box-shadow ${LAUNCHER_EXPAND_DURATION_MS}ms ease`,
  '&:hover': {
    background: LAUNCHER_GRADIENT,
    boxShadow: `0 12px 32px ${alpha(COLOR_PALETTE.BRAND[6], LAUNCHER_SHADOW_HOVER_OPACITY)}`,
  },
  '&:focus-visible': {
    outline: `2px solid ${COLOR_PALETTE.BRAND[3]}`,
    outlineOffset: '2px',
  },
  [mediaQuery.mobile]: {
    height: `${LAUNCHER_COLLAPSED_SIZE_MOBILE}px`,
    minWidth: `${LAUNCHER_COLLAPSED_SIZE_MOBILE}px`,
    width: isExpanded ? '240px' : `${LAUNCHER_COLLAPSED_SIZE_MOBILE}px`,
    borderRadius: `${LAUNCHER_COLLAPSED_SIZE_MOBILE / 2}px`,
  },
});

export const launcherIconWrapperStyles = {
  width: `${LAUNCHER_COLLAPSED_SIZE}px`,
  height: `${LAUNCHER_COLLAPSED_SIZE}px`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  [mediaQuery.mobile]: {
    width: `${LAUNCHER_COLLAPSED_SIZE_MOBILE}px`,
    height: `${LAUNCHER_COLLAPSED_SIZE_MOBILE}px`,
  },
};

export const launcherLabelWrapperStyles = isExpanded => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  marginLeft: isExpanded ? '12px' : 0,
  maxWidth: isExpanded ? '220px' : 0,
  opacity: isExpanded ? 1 : 0,
  transition: `max-width ${LAUNCHER_EXPAND_DURATION_MS}ms ease, margin-left ${LAUNCHER_EXPAND_DURATION_MS}ms ease, opacity ${LAUNCHER_EXPAND_DURATION_MS}ms ease`,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  minWidth: 0,
});

export const launcherPrimaryLabelStyles = {
  color: COLOR_PALETTE.GRAY[1],
};

export const launcherSecondaryLabelStyles = {
  color: COLOR_PALETTE.BLUE[2],
  opacity: 0.95,
};

export const launcherBadgeStyles = {
  '& .MuiBadge-badge': {
    top: 6,
    right: 6,
    backgroundColor: COLOR_PALETTE.RED[7],
    color: COLOR_PALETTE.GRAY[1],
    border: ({ palette }) => `2px solid ${palette.background.primary}`,
    fontSize: '11px',
    fontWeight: 700,
    minWidth: '20px',
    height: '20px',
    padding: '0 5px',
  },
};
